import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=bb897e6c&"
import script from "./CourseForm.vue?vue&type=script&lang=js&"
export * from "./CourseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb897e6c')) {
      api.createRecord('bb897e6c', component.options)
    } else {
      api.reload('bb897e6c', component.options)
    }
    module.hot.accept("./CourseForm.vue?vue&type=template&id=bb897e6c&", function () {
      api.rerender('bb897e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/CourseForm.vue"
export default component.exports